import { normalize } from "@/lib/format";

/**
 * O tipo de produto padrão.
 *
 * Os tipos de produto são a coleção `categories` (a interface já os chamou de
 * categorias), e servem à busca do app do cliente. O tipo é opcional no
 * produto: o que fica sem tipo grava `products.category = "outros"`, um id que
 * NÃO existe na coleção. Por isso o painel o mostra como fixo, fora da lista e
 * da reordenação, e não deixa criar outro com o mesmo nome.
 *
 * As mesmas constantes estão em `zepadoca-functions` (`utils/productTypes.ts`)
 * e em `constants/productTypes.ts` dos dois aplicativos. Mudar uma é mudar as
 * quatro.
 */
export const DEFAULT_PRODUCT_TYPE_ID = "outros";
export const DEFAULT_PRODUCT_TYPE_NAME = "Outros";

/** Verdadeiro para "Outros", sem olhar acento, caixa nem espaço nas pontas. */
export function isReservedProductTypeName(name: string): boolean {
  return normalize(name).replace(/[^a-z0-9]+/g, "") === DEFAULT_PRODUCT_TYPE_ID;
}

/**
 * O nome do tipo de um produto, para conferência: o do documento, "Outros"
 * para o padrão (e para o produto antigo sem o campo), e um aviso quando o id
 * não está mais na coleção. Num painel de gestão, mostrar "Outros" para um
 * tipo apagado esconderia justamente o que precisa ser corrigido.
 */
export function productTypeName(
  categoryId: string | undefined,
  names: Map<string, string | undefined>,
): string {
  if (!categoryId || categoryId === DEFAULT_PRODUCT_TYPE_ID) return DEFAULT_PRODUCT_TYPE_NAME;
  if (!names.has(categoryId)) return "Tipo não encontrado";
  return names.get(categoryId) || "Sem nome";
}
